module.exports = __webpack_public_path__ + "static/media/ProximaNova-Extrabold.5243e362.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova-Extrabold.otf
// module id = 2100
// module chunks = 53